var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pending-approval" },
    [
      _c(
        "div",
        { staticClass: "blocks-list" },
        _vm._l(_vm.blocks, function (block) {
          return _c("div", { key: block._id, staticClass: "block-item" }, [
            _c("div", { staticClass: "block-info" }, [
              _c("span", { staticClass: "material-icons block-icon" }, [
                _vm._v(_vm._s(block.icon || "extension")),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "block-details" }, [
                _c("h3", [_vm._v(_vm._s(block.name))]),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(block.description))]),
                _vm._v(" "),
                _c("div", { staticClass: "block-meta" }, [
                  _c("span", { staticClass: "creator" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("chatbotv2.creator") || "Creator") +
                        ": " +
                        _vm._s(block.siteId) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "created-date" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.formatDate(block.createdAt)) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "block-actions" },
              [
                _c(
                  "a-button",
                  {
                    attrs: { size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.viewDetails(block._id)
                      },
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "eye" } }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.viewDetails") || "View") +
                        "\n                "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.approveBlock(block._id)
                      },
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "check" } }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.approve") || "Approve") +
                        "\n                "
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-button",
                  {
                    attrs: { size: "small", type: "danger" },
                    on: {
                      click: function ($event) {
                        return _vm.rejectBlock(block._id)
                      },
                    },
                  },
                  [
                    _c("a-icon", { attrs: { type: "close" } }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("chatbotv2.reject") || "Reject") +
                        "\n                "
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.blocks.length === 0
        ? _c(
            "div",
            { staticClass: "empty-state" },
            [
              _c("a-empty", {
                attrs: {
                  description:
                    _vm.$t("chatbotv2.noPendingBlocks") || "No pending blocks",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showRejectionModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("chatbotv2.rejectBlock") || "Reject Block",
                description:
                  _vm.$t("chatbotv2.enterRejectionReason") ||
                  "Enter rejection reason",
                okText: _vm.$t("chatbotv2.reject") || "Reject",
                cancelText: _vm.$t("message.cancel") || "Cancel",
              },
              on: {
                ok: _vm.confirmReject,
                cancel: function ($event) {
                  _vm.showRejectionModal = false
                },
              },
            },
            [
              _c("a-textarea", {
                attrs: {
                  rows: 5,
                  placeholder:
                    _vm.$t("chatbotv2.rejectionReasonPlaceholder") ||
                    "Explain why this block is being rejected...",
                },
                model: {
                  value: _vm.rejectionReason,
                  callback: function ($$v) {
                    _vm.rejectionReason = $$v
                  },
                  expression: "rejectionReason",
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }